import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { hideLoader } from '../../store/app/actions';
import { setSessionExpired, setLimitedSessionStart } from '../../store/app';
import { HOOK_TYPE, APP_EVENTS, PLAYER_STATES, SOCKET_PRIMARY_ROUTE, SOCKET_SECONDARY_ROUTE } from '../../constants';
import './event-expire.css';

const EventExpired = ({
  ctrl,
  title,
  desc,
  allowedUserTime,
  elapsedTime,
  hookUrl,
  hookBehavior,
  sessionExpired,
  playerState,
  DRMode,
  sessionState,
  setLimitedSessionStart,
}) => {
  const [openPopUp, setPopUp] = useState(false);
  const [duration, setDuration] = useState(0);
  const durationTimer = useRef(null);

  useEffect(() => {
    setDuration(elapsedTime);
    if (elapsedTime > allowedUserTime && !sessionExpired) {
      ctrl.session.onSessionExpire();
    }
    //eslint-disable-next-line
  }, [elapsedTime]);

  useEffect(() => {
    if (playerState === PLAYER_STATES.STARTED && elapsedTime < allowedUserTime) {
      startTimer();
      setLimitedSessionStart();
      if (!DRMode && ctrl.session.socket) {
        ctrl.session.socket.send(
          `${SOCKET_PRIMARY_ROUTE.OPERATION}${SOCKET_SECONDARY_ROUTE.PLAYBACK_STARTED}{"p": true}`,
        );
      } else {
        ctrl.session.onPlaybackStarted();
      }
    } else if (playerState === PLAYER_STATES.PAUSED && elapsedTime < allowedUserTime) {
      clearInterval(durationTimer.current);
      if (!DRMode && ctrl.session.socket) {
        ctrl.session.socket.send(
          `${SOCKET_PRIMARY_ROUTE.OPERATION}${SOCKET_SECONDARY_ROUTE.PLAYBACK_STARTED}{"p": false}`,
        );
      } else {
        ctrl.session.onPlaybackStarted();
      }
    }
    //eslint-disable-next-line
  }, [playerState]);

  useEffect(() => {
    if (sessionExpired) {
      initiateHook();
    }
    //eslint-disable-next-line
  }, [sessionExpired]);

  useEffect(() => {
    return () => {
      if (durationTimer.current) {
        clearInterval(durationTimer.current);
      }
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (duration >= allowedUserTime) {
      clearInterval(durationTimer.current);
      if (!sessionExpired) {
        ctrl.session.onSessionExpire();
      }
    }
    //eslint-disable-next-line
  }, [duration]);

  const startTimer = () => {
    durationTimer.current && clearInterval(durationTimer.current);
    durationTimer.current = setInterval(() => {
      setDuration((duration) => duration + 1000);
    }, 1000);
  };

  const initiateHook = () => {
    switch (hookBehavior) {
      case HOOK_TYPE.EMITEVENT || HOOK_TYPE.EMITEVENT_CMS:
        ctrl.emit(APP_EVENTS.SESSION_EXPIRED);
        break;
      case HOOK_TYPE.POPUP:
        setPopUp(true);
        break;
      case HOOK_TYPE.REDIRECT:
        window.open(hookUrl, '_self');
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      {sessionExpired ? (
        <div className="popup">
          {openPopUp ? (
            <div className={`eventExpireNote cPos ${isMobile ? 'mobile' : ''}`}>
              <iframe src={`${hookUrl}`} title="popup"></iframe>
            </div>
          ) : (
            <div className="eventExpireNote cPos">
              <div className="eventExpireInner">
                <div className="eventExpireHdng">
                  <p className="title">{title}</p>
                  <p className="byline">{desc}</p>
                </div>
                <div className="eventExpireMessage">Session Timed out</div>
              </div>
            </div>
          )}
        </div>
      ) : null}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    title: state.app.title,
    desc: state.app.desc,
    allowedUserTime: state.app.allowedUserTime,
    elapsedTime: state.app.elapsedTime,
    hookUrl: state.app.hookUrl,
    hookBehavior: state.app.hookBehavior,
    sessionExpired: state.app.sessionExpired,
    playerState: state.app.playerState,
    DRMode: state.app.DRMode,
    sessionState: state.app.sessionState,
  };
};

const mapDispatchToProps = {
  hideLoader,
  setSessionExpired,
  setLimitedSessionStart,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventExpired);
